export const formatPoints = (points) => {
  if (points > 0) return `+${points}`;
  if (points < 0) return `−${Math.abs(points)}`;
  return '0';
};

export const formatTotal = (points) => (points < 0 ? `−${Math.abs(points)}` : `${points}`);

export const playerTotal = (rounds, playerId) =>
  rounds.reduce(
    (sum, round) => sum + (round.scores.find((s) => s.playerId === playerId)?.score ?? 0),
    0
  );
